document.addEventListener("DOMContentLoaded", () => {
  // --- 要素の取得 ---
  const headerBtn = document.querySelector(".header-btn") as HTMLElement | null;
  const headerSp = document.querySelector(".header-sp") as HTMLElement | null;
  const openModalBtn = document.querySelector(".js-open-modal") as HTMLElement | null;
  const closeModalBtn = document.querySelector(".js-close-modal") as HTMLElement | null;
  const modal = document.getElementById("modal") as HTMLElement | null;
  const tab01 = document.getElementById("compatible__tab01") as HTMLInputElement | null;
  const tab02 = document.getElementById("compatible__tab02") as HTMLInputElement | null;
  const warekiSelect = document.getElementById("item03_wareki") as HTMLSelectElement | null;
  const item03Month = document.getElementById("item03_month") as HTMLSelectElement | null;
  const license_searchButton = document.getElementById("license_searchButton") as HTMLButtonElement;
  // const maker_searchButton = document.getElementById("maker_searchButton") as HTMLButtonElement;
  const search_form = document.getElementById("search-form") as HTMLFormElement | null;
  const form = document.getElementById("search-license_form") as HTMLFormElement | null;
  // const resetButton = document.getElementById("license_reset") as HTMLButtonElement;
  // const resetButton = document.querySelectorAll(".license_reset") as HTMLElement | null;
  const resetButtons = document.querySelectorAll(".license_reset");
  const compatibleArchiveLink = document.querySelector(
    ".compatible__archive--link--btn.btn-simple",
  ) as HTMLAnchorElement | null;

  // --- ヘッダーの開閉処理 ---
  if (headerBtn && headerSp) {
    const toggleHeader = () => {
      headerBtn.classList.toggle("open");
      headerSp.classList.toggle("open");
    };

    headerBtn.addEventListener("click", toggleHeader);
    headerSp.querySelectorAll("a").forEach((link) => link.addEventListener("click", toggleHeader));
  }

  // --- モーダルの開閉処理 ---
  if (openModalBtn && modal && closeModalBtn) {
    const openModal = (e: Event) => {
      e.preventDefault();
      modal.style.display = "block";
      modal.classList.add("fade-in");
    };

    const closeModal = () => {
      modal.classList.remove("fade-in");
      modal.classList.add("fade-out");
      setTimeout(() => {
        modal.style.display = "none";
        modal.classList.remove("fade-out");
      }, 300);
    };

    openModalBtn.addEventListener("click", openModal);
    closeModalBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  }

  // --- タブの切り替え処理 ---
  if (window.innerWidth <= 768) {
    if (tab01 && tab02) {
      tab01.addEventListener("change", function () {
        if (tab01.checked) window.location.href = "/compatible/";
      });

      tab02.addEventListener("change", function () {
        if (tab02.checked) window.location.href = "/car_license_api/";
      });
    }
  }
// --- 和暦年変換処理 ---
if (warekiSelect && item03Month) {
  const warekiYears = [
    { name: "昭和", startYear: 1926, endYear: 1989 },
    { name: "平成", startYear: 1989, endYear: 2019 }, // 2019年4月までが平成
    { name: "令和", startYear: 2019 },
  ];

  // 全体の最初に "--" を追加
  const placeholderOption = document.createElement("option");
  placeholderOption.value = "00";
  placeholderOption.text = "-----";
  warekiSelect.appendChild(placeholderOption);

  warekiYears.forEach((wareki) => {
    for (
      let year = wareki.name === "昭和" ? 1950 : wareki.startYear;
      year <= (wareki.endYear || new Date().getFullYear());
      year++
    ) {
      let warekiYear;
      if (wareki.name === "昭和" && year - wareki.startYear + 1 < 1) {
        warekiYear = "元年";
      } else if (wareki.name === "令和" && year === 2019) {
        warekiYear = "元年"; // 2019年は元年
      } else {
        warekiYear = year - wareki.startYear + 1 + "年";
      }

      const option = document.createElement("option");
      option.value = year.toString();
      option.text = `${wareki.name}${warekiYear} (${year}年)`;
      warekiSelect.appendChild(option);
    }
  });

  warekiSelect.value = "00"; // 初期値
  item03Month.value = "00"; // 初期値

  const updateHiddenInput = () => {
    const selectedWarekiYear = warekiSelect.value;
    const selectedMonth = item03Month.value;
    (document.getElementById("item03") as HTMLInputElement).value = `${selectedWarekiYear}/${selectedMonth}`;
  };

  warekiSelect.addEventListener("change", updateHiddenInput);
  item03Month.addEventListener("change", updateHiddenInput);
}

  // // --- 選択内容の保存処理 ---
  const saveSelectionsToLocalStorage = () => {
    localStorage.setItem("selectedWareki", warekiSelect.value);
    localStorage.setItem("selectedMonth", item03Month.value);
  };

  // // --- 選択内容の復元処理 ---
  const loadSelectionsFromLocalStorage = () => {
    const savedWareki = localStorage.getItem("selectedWareki");
    const savedMonth = localStorage.getItem("selectedMonth");

    if (savedWareki) warekiSelect.value = savedWareki;
    if (savedMonth) item03Month.value = savedMonth;
  };

  // ページ読み込み時に選択内容を復元
  loadSelectionsFromLocalStorage();

  // 検索ボタンがクリックされたときに選択内容を保存
  if (license_searchButton) {
    license_searchButton.addEventListener("click", saveSelectionsToLocalStorage);
  }

  // --- 全角を半角に変換する処理 ---
  if (window.location.pathname === "/compatible/") {
    // const fullWidthPattern = /[^\x00-\x7F]/g;
    const fullWidthPattern = /[^\u0020-\u007E]/g;
    const inputFields = document.querySelectorAll('input[type="text"], input[type="number"]') as NodeList;

    inputFields.forEach((inputField) => {
      inputField.addEventListener("input", function () {
        const errorMessage = inputField.nextElementSibling as HTMLElement;
        if (fullWidthPattern.test(inputField.value)) {
          if (errorMessage && errorMessage.classList.contains("error-message")) {
            errorMessage.style.display = "block";
          }
        } else {
          if (errorMessage && errorMessage.classList.contains("error-message")) {
            errorMessage.style.display = "none";
          }
        }
        inputField.value = inputField.value.replace(fullWidthPattern, "");
      });
    });
  }

  // --- 車検取り込み機能 ---
  if (window.location.pathname === "/car_license_api/") {
    const setCompatibleArchiveLink = () => {
      if (!compatibleArchiveLink) return;

      const androidUrl ="https://www.e-shaken.mlit.go.jp/etsuran01/?service_id=003&access_id=AID000000002511&access_key=a5297db8-e486-497a-aeda-38843aa5ad50";
      const iphoneUrl ="https://www.e-shaken.mlit.go.jp/etsuran/?service_id=003&access_id=AID000000002511&access_key=a5297db8-e486-497a-aeda-38843aa5ad50";
    // const androidUrl = "https://google.co.jp/";
    // const iphoneUrl = "https://yahoo.co.jp/";

      const userAgent = navigator.userAgent || navigator.vendor;
      compatibleArchiveLink.href = /android/i.test(userAgent)
        ? androidUrl
        : /iPad|iPhone|iPod/.test(userAgent)
        ? iphoneUrl
        : compatibleArchiveLink.href;
    };
    setCompatibleArchiveLink();

    //    document.getElementById('carInfoForm').addEventListener('submit', function() {
    //     const inputValue = document.getElementById('electCertMgNo').value;
    //     if (inputValue) {
    //         localStorage.setItem('electCertMgNo', inputValue);
    //     }
    // });

    // const electCertMgNoValue = localStorage.getItem('electCertMgNo');

    // // 値が存在すれば、入力欄の value にセット
    // if (electCertMgNoValue) {
    //     document.getElementById('electCertMgNo').value = electCertMgNoValue;
    // }

    // const clearLink = document.getElementById('search-link--btn');
    const storageKey = 'electCertMgNo';
        const inputField = document.getElementById('electCertMgNo');
        const form = document.getElementById('carInfoForm');
        const clearLink = document.getElementById('search-link--btn');

        // ページロード時にLocalStorageの値を取得して入力欄にセット
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue) {
            inputField.value = storedValue;
        }

        // フォーム送信時にLocalStorageへ値を保存
        form.addEventListener('submit', function() {
            const inputValue = inputField.value;
            if (inputValue) {
                localStorage.setItem(storageKey, inputValue);
            }
        });

        // リンククリック時にLocalStorageのelectCertMgNoを削除
        clearLink.addEventListener('click', function() {
            localStorage.removeItem(storageKey);
            console.log(`${storageKey} has been removed from localStorage.`);
        });

  }



  // 共通のローカルストレージ保存関数
  const saveToLocalStorage = (data: object) => {
    try {
      localStorage.setItem("searchLicenseFormData", JSON.stringify(data));
      console.log("ローカルストレージに保存:", data);
    } catch (error) {
      console.error("ローカルストレージへの保存中にエラーが発生:", error);
    }
  };

  // search-form用の保存処理
  const saveSearchFormData = () => {
    const formData = {
      item01: "",
      item02: "",
      item03: "",
      item04: "",
      item05: "",
      item06: "",
      item07: (document.getElementById("item07") as HTMLInputElement)?.value.trim() || "",
      item_kind: "",
      date: new Date().toLocaleString("ja-JP", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    };

    saveToLocalStorage(formData);
  };

  // search-license_form用の保存処理
  const saveSearchLicenseFormData = () => {
    const warekiSelect = document.getElementById("item03_wareki") as HTMLSelectElement;
    const item03Month = document.getElementById("item03_month") as HTMLSelectElement;
    const item07Element = document.getElementById("item07") as HTMLInputElement;
    const formData = {
      item01: (document.querySelector('select[name="item01"]') as HTMLSelectElement)?.value || "",
      item02: (document.getElementById("item02") as HTMLInputElement)?.value.trim() || "",
      item03: `${warekiSelect?.value || ""}/${item03Month?.value || ""}`,
      item04: (document.getElementById("item04") as HTMLInputElement)?.value.trim() || "",
      item05: (document.getElementById("item05") as HTMLInputElement)?.value.trim() || "",
      item06: (document.getElementById("item06") as HTMLInputElement)?.value.trim() || "",
      item07: "",
      item_kind:
        Array.from(document.querySelectorAll('input[name="item_kind[]"]:checked'))
          .map((input) => (input as HTMLInputElement).value)
          .join(",") || "",
      date: new Date().toLocaleString("ja-JP", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    };

    saveToLocalStorage(formData);
    // item07の値をクリア
    if (item07Element) {
      item07Element.value = "";
      console.log("item07の値をクリアしました");
    }
  };

  // フォーム送信時の処理
  const handleFormSubmit = (form: HTMLFormElement, saveFunction: () => void) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault(); // デフォルト送信を防止
      saveFunction(); // データを保存
      form.submit(); // 実際の送信を実行
    });

    setTimeout(() => {
      // URLにクエリ文字列 (/? など) が含まれている場合のみハッシュを追加
      if (window.location.search && !window.location.hash.includes("#compatible__result")) {
        window.location.href += "#compatible__result";
      }
    }, 300);

  };

  // フォーム取得とイベント設定
  const searchForm = document.getElementById("search-form") as HTMLFormElement;
  const searchLicenseForm = document.getElementById("search-license_form") as HTMLFormElement;

  if (searchForm) {
    handleFormSubmit(searchForm, saveSearchFormData);
  } else {
    console.warn("search-formが見つかりません");
  }

  if (searchLicenseForm) {
    handleFormSubmit(searchLicenseForm, saveSearchLicenseFormData);
  } else {
    console.warn("search-license_formが見つかりません");
  }
  // });

  // --- ローカルストレージのクリア、フォームのリセット、URLのパラメーター削除 ---
  resetButtons.forEach((resetButton) => {
    resetButton.addEventListener("click", (event) => {
      event.preventDefault(); // デフォルトのリセット動作を防止

      const form = resetButton.closest("form") as HTMLFormElement;
      if (form) {
        form.reset();
        localStorage.removeItem("searchLicenseFormData");

        // 各入力フィールドの値を手動でクリア（存在確認を追加）
        const item01 = form.querySelector('select[name="item01"]') as HTMLSelectElement | null;
        if (item01) item01.value = "";

        const item02 = form.querySelector("#item02") as HTMLInputElement | null;
        if (item02) item02.value = "";

        const item03 = form.querySelector("#item03") as HTMLInputElement | null;
        if (item03) item03.value = "";

        const item04 = form.querySelector("#item04") as HTMLInputElement | null;
        if (item04) item04.value = "";

        const item05 = form.querySelector("#item05") as HTMLInputElement | null;
        if (item05) item05.value = "";

        const item06 = form.querySelector("#item06") as HTMLInputElement | null;
        if (item06) item06.value = "";

        const item07 = form.querySelector("#item07") as HTMLInputElement | null;
        if (item07) item07.value = "";

        // チェックボックスの選択をクリア
        form.querySelectorAll('input[name="item_kind[]"]').forEach((checkbox) => {
          (checkbox as HTMLInputElement).checked = false;
        });
      }

      // URLのパラメーターを削除
      try {
        const url = new URL(window.location.href);
        url.search = ""; // クエリパラメーターをクリア
        window.history.replaceState({}, document.title, url.toString());
      } catch (error) {
        console.error("URLパラメーター削除エラー:", error);
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const searchResultElement = document.getElementById("searchResult");

  if (searchResultElement) {
    const resultValue = (searchResultElement as HTMLInputElement).value.trim();
    const resultData = resultValue === "○" ? "○" : "X";

    // LocalStorageに保存
    try {
      const existingData = JSON.parse(localStorage.getItem("searchLicenseFormData") || "{}");
      existingData.result = resultData; // resultを更新または追加
      localStorage.setItem("searchLicenseFormData", JSON.stringify(existingData));
      console.log(`ローカルストレージに保存: result=${resultData}`);
    } catch (error) {
      console.error("ローカルストレージへの保存中にエラーが発生:", error);
    }
  } else {
    console.warn("searchResult要素が見つかりません");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const searchResultElement = document.getElementById("searchResult");

  if (searchResultElement) {
    const resultValue = (searchResultElement as HTMLInputElement).value.trim();
    const formData = JSON.parse(localStorage.getItem("searchLicenseFormData") || "{}");

    // 検索結果とタイムスタンプを追加
    formData.searchResult = {
      result: resultValue,
      timestamp: new Date().toISOString(),
    };

    // サーバーに送信
    fetch("/wp-json/save-result/v1/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("サーバーへの保存に失敗しました");
        }
        console.log("サーバーに保存成功:", response);
      })
      .catch((error) => {
        console.error("サーバーへの送信中にエラー:", error);
      });
  } else {
    console.warn("searchResult要素が見つかりません");
  }
});


document.addEventListener('DOMContentLoaded', function () {
    const saveSuccessElement = document.getElementById('save-success');

    // localStorage から carNo を取得
    const carNo = localStorage.getItem('carNo');

    // carNo が存在する場合は表示、存在しない場合は非表示
    if (carNo) {
        saveSuccessElement.style.display = 'block';
    } else {
        saveSuccessElement.style.display = 'none';
    }
});
